import { IServiceWallet, IServiceWalletDTO } from '@api/FW/serviceWallets/types';

export const serviceWalletsAdapter = (data: IServiceWalletDTO[]): IServiceWallet[] =>
	data.map(
		({
			ИдСчета,
			КоличествоКарт,
			СчетВыводитьВСчетФактуру,
			ИдКонтрагента,
			СчетВид,
			СчетСостояние,
			СчетКонтрагентНаименование,
			СчетНаименование,
			СчетКод,
			Счет,
		}) => ({
			walletId: ИдСчета,
			cardsAmount: КоличествоКарт,
			invoiceWithdrawInvoice: СчетВыводитьВСчетФактуру,
			contractorID: ИдКонтрагента,
			walletType: СчетВид,
			walletState: СчетСостояние,
			walletCounterpartyName: СчетКонтрагентНаименование,
			walletName: СчетНаименование,
			walletCode: СчетКод,
			walletGUID: Счет,
		}),
	);
